import { cx } from "class-variance-authority";

import { ReactComponent as LogoInner } from "./assets/logo-inner.svg";
import { ReactComponent as LogoOuter } from "./assets/logo-outer.svg";
import * as styles from "./Loader.module.scss";

export const LoaderIcon = ({
  className,
  loading = true,
}: {
  className?: string;
  loading?: boolean;
}) => {
  return (
    <div className={className}>
      <LogoOuter />
      <LogoInner
        className={cx(styles.rotate, {
          [styles.rotating]: loading,
        })}
      />
    </div>
  );
};
